export function preseedForm() {
	return {
		name: '',
		language: 'en',
		country: 'DE',
		locale: 'en_US.UTF-8',
		keymap: 'de',
		configureNetworkManually: true,
		ipAddress: '192.168.1.42',
		ipNetmask: '255.255.255.0',
		ipGateway: '192.168.1.1',
		ipNameservers: '1.1.1.1 8.8.8.8',
		hostname: 'server.example.com',
		mirrorCountry: 'manual',
		mirrorHostname: 'ftp.de.debian.org',
		mirrorDirectory: '/debian',
		createRoot: true,
		rootPassword: '',
		rootPasswordConfirm: '',
		createUser: true,
		userFullname: 'Debian',
		userUsername: 'debian',
		userPassword: '',
		userPasswordConfirm: '',
		setUserSSHKey: false,
		userSSHKey: '',
		timezone: 'Europe/Berlin',
		isEFI: false,
		partmanMemory: 1,
		partmanSpace: 30,
		partmanDisk: '/dev/vda',
		partmanSwap: 1024,
		partmanRoot: 4096,
		aptArch: 'amd64',
		errors: {},
		cidrHintMsg: 'Press Tab to auto-fill netmask',

		init() {
			const el = document.getElementById('initial-config');
			if (el) {
				try {
					const cfg = JSON.parse(el.textContent);
					for (const [key, value] of Object.entries(cfg)) {
						if (key in this && key !== 'errors') {
							this[key] = value;
						}
					}
				} catch (e) {
					console.warn('Failed to parse initial config:', e);
				}
			}
		},

		get isValid() {
			return Object.keys(this.errors).length === 0;
		},

		updateUsername() {
			this.userUsername = this.userFullname.toLowerCase().replace(/[^a-z0-9]/g, '');
		},

		computeSwap() {
			const memMB = this.partmanMemory * 1024;
			if (memMB < 1024) {
				this.partmanSwap = memMB;
				return;
			}
			const sqrtGB = Math.floor(Math.sqrt(this.partmanMemory));
			let power = 1;
			while (power < sqrtGB) power <<= 1;
			this.partmanSwap = power * 1024;
		},

		computeRoot() {
			const v = Math.ceil(this.partmanSpace * 10 / 100);
			this.partmanRoot = Math.max(4, v) * 1024;
		},

		validatePasswords() {
			if (this.createRoot && this.rootPassword !== this.rootPasswordConfirm) {
				this.errors.rootPassword = 'Does not match to confirmation';
			} else {
				delete this.errors.rootPassword;
			}
			if (this.createUser && this.userPassword !== this.userPasswordConfirm) {
				this.errors.userPassword = 'Does not match to confirmation';
			} else {
				delete this.errors.userPassword;
			}
		},

		isValidIP(addr) {
			// IPv4
			const m4 = addr.match(/^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/);
			if (m4) return m4.slice(1).every(n => parseInt(n, 10) <= 255);
			// IPv6 (basic check: contains colon, valid hex chars)
			return addr.includes(':') && /^[0-9a-fA-F:]+$/.test(addr);
		},

		ipVersionLabel() {
			const val = this.ipAddress.split('/')[0].trim();
			if (/^(\d{1,3}\.){3}\d{1,3}$/.test(val)) return 'v4';
			if (val.includes(':')) return 'v6';
			return '';
		},

		isValidNetmask(mask) {
			// Accept a valid dotted-decimal IPv4 address (IPv4 netmask)
			if (this.isValidIP(mask)) return true;
			// Accept a plain integer 0–128 (IPv6 prefix length used as netmask)
			const n = parseInt(mask, 10);
			return /^\d+$/.test(mask) && n >= 0 && n <= 128;
		},

		cidrPrefixToNetmask(prefix) {
			const p = parseInt(prefix, 10);
			if (p < 0 || p > 32) return null;
			const mask = p === 0 ? 0 : ((0xFFFFFFFF << (32 - p)) >>> 0);
			return [
				(mask >>> 24) & 0xFF,
				(mask >>> 16) & 0xFF,
				(mask >>> 8)  & 0xFF,
				mask          & 0xFF,
			].join('.');
		},

		parseCIDR() {
			const val = this.ipAddress.trim();
			const slash = val.lastIndexOf('/');
			if (slash === -1) return;
			const host = val.slice(0, slash);
			const prefix = val.slice(slash + 1);
			if (!/^\d+$/.test(prefix)) return;
			const prefixNum = parseInt(prefix, 10);
			const isIPv4Host = /^(\d{1,3}\.){3}\d{1,3}$/.test(host);
			if (isIPv4Host && prefixNum >= 0 && prefixNum <= 32) {
				this.ipAddress = host;
				this.ipNetmask = this.cidrPrefixToNetmask(prefixNum);
			} else if (!isIPv4Host && prefixNum >= 0 && prefixNum <= 128) {
				this.ipAddress = host;
				this.ipNetmask = prefix;
			}
			this.validateIPs();
		},

		validateIPs() {
			if (!this.configureNetworkManually) {
				delete this.errors.ipAddress;
				delete this.errors.ipNetmask;
				delete this.errors.ipGateway;
				delete this.errors.ipNameservers;
				return;
			}
			// Detect CIDR notation (host/prefix) and show a hint instead of an error.
			const addr = this.ipAddress.trim();
			const slashIdx = addr.lastIndexOf('/');
			if (slashIdx !== -1 && /^\d+$/.test(addr.slice(slashIdx + 1))) {
				const host = addr.slice(0, slashIdx);
				const prefixNum = parseInt(addr.slice(slashIdx + 1), 10);
				const isIPv4Host = /^(\d{1,3}\.){3}\d{1,3}$/.test(host) &&
					host.split('.').every(n => parseInt(n, 10) <= 255);
				if (isIPv4Host && prefixNum >= 0 && prefixNum <= 32) {
					this.errors.ipAddress = this.cidrHintMsg;
				} else if (isIPv4Host) {
					this.errors.ipAddress = 'Invalid CIDR prefix for IPv4 (must be 0–32)';
				} else if (host.includes(':') && prefixNum >= 0 && prefixNum <= 128) {
					this.errors.ipAddress = this.cidrHintMsg;
				} else if (host.includes(':')) {
					this.errors.ipAddress = 'Invalid CIDR prefix for IPv6 (must be 0–128)';
				} else {
					this.errors.ipAddress = 'Invalid ip address';
				}
			} else if (!this.isValidIP(addr)) {
				this.errors.ipAddress = 'Invalid ip address';
			} else {
				delete this.errors.ipAddress;
			}
			if (!this.isValidNetmask(this.ipNetmask)) {
				this.errors.ipNetmask = 'Invalid netmask';
			} else {
				delete this.errors.ipNetmask;
			}
			if (!this.isValidIP(this.ipGateway)) {
				this.errors.ipGateway = 'Invalid ip address';
			} else {
				delete this.errors.ipGateway;
			}
			const badNS = this.ipNameservers.trim().split(/\s+/).find(a => !this.isValidIP(a));
			if (badNS) {
				this.errors.ipNameservers = 'Invalid ip address ' + badNS;
			} else {
				delete this.errors.ipNameservers;
			}
		},

		validateSSHKey() {
			if (!this.setUserSSHKey || !this.userSSHKey.trim()) {
				delete this.errors.userSSHKey;
				return;
			}
			const validTypes = [
				'ssh-rsa', 'ssh-ed25519', 'ssh-dss',
				'ecdsa-sha2-nistp256', 'ecdsa-sha2-nistp384', 'ecdsa-sha2-nistp521',
				'sk-ssh-ed25519@openssh.com', 'sk-ecdsa-sha2-nistp256@openssh.com',
			];
			const parts = this.userSSHKey.trim().split(/\s+/);
			if (parts.length < 2 || !validTypes.includes(parts[0])) {
				this.errors.userSSHKey = 'Invalid SSH public key';
			} else {
				delete this.errors.userSSHKey;
			}
		},
	};
}
